const $ = jQuery.noConflict();

const vhUnit = () => {
	document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
	document.documentElement.style.setProperty('--heroHeight', `${$('.lp-hero').outerHeight()}px`);
};

export default vhUnit;
